import React, { forwardRef } from 'react';
import styles from './style.module.scss';

const InputComponent = forwardRef((props, ref) => {
  const {
    type,
    name,
    value,
    placeholder,
    disabled,
    onclick,
    handleChange,
    error,
    maxLength,
    minLength,
    isInputNumber,
    inputStyles,
    marginBottom,
    wrapperStyles,
    otherData,
    title,
    className,
    errorStyle,
    ...rest
  } = props;
  return (
    <>
      <label className={`${styles.customLabel} my-2`}>{title}</label>
      <input
        ref={ref}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onClick={onclick}
        className={`${styles.inputBox} ${className ? className : ''}`}
        onChange={(e) => typeof handleChange === 'function' && handleChange(e, otherData)}
        style={inputStyles}
        {...rest}
      />
      {error && (
        <p className="text-danger mb-0" style={errorStyle}>
          {error}
        </p>
      )}
    </>
  );
});

export default InputComponent;
